import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { Checkbox } from "@blueprintjs/core";
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useHistory } from "react-router-dom";

import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'

import { FormIvInfo } from '../Types'
import { SystemHeader, AutoPrint } from '../CommonUI';

import i18next from 'i18next';

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

interface PageInfo {
    n: number
}

var GsbFlag: any;



interface FormIVEntryMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function FormIVEntryMain({ gsb }: FormIVEntryMainProps) {

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))
    

    let ProgressId2 = ""
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    const history = useHistory()

    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)

    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptName, setRptName] = useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)


    const [Data, setData] = useState([] as FormIvInfo[])

    const [searchKey, setSearchKey] = useState("StkNo")

    const [showFilters, setShowFilters] = useState(false)
    const [searchStkNo, setsearchStkNo] = useState("")
    const [showButton, setshowButton] = useState(true)
    const [ShowWait, setShowWait] = useState(false)
    const [isReadRec, setisReadRec] = useState(false)


    const [DataFormatValue, setDataFormatValue] = useState(false)
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentFormIV, setcurrentFormIV] = useState({} as FormIvInfo)

    const [currentMode, setcurrentMode] = useState("show")

    const [n_001, setn_001] = useState("0")
    const [n_101, setn_101] = useState("0")
    const [n_201, setn_201] = useState("0")


    const [n_002, setn_002] = useState("0")
    const [n_102, setn_102] = useState("0")
    const [n_202, setn_202] = useState("0")

    const [n_003, setn_003] = useState("0")
    const [n_103, setn_103] = useState("0")
    const [n_203, setn_203] = useState("0")

    const [n_004, setn_004] = useState("0")
    const [n_104, setn_104] = useState("0")
    const [n_204, setn_204] = useState("0")

    const [n_005, setn_005] = useState("0")
    const [n_105, setn_105] = useState("0")
    const [n_205, setn_205] = useState("0")

    const [n_006, setn_006] = useState("0")
    const [n_106, setn_106] = useState("0")
    const [n_206, setn_206] = useState("0")

    const [n_007, setn_007] = useState("0")
    const [n_107, setn_107] = useState("0")
    const [n_207, setn_207] = useState("0")

    const [n_008, setn_008] = useState("0")
    const [n_108, setn_108] = useState("0")
    const [n_208, setn_208] = useState("0")

    const [n_009, setn_009] = useState("0")
    const [n_109, setn_109] = useState("0")
    const [n_209, setn_209] = useState("0")

    const [n_010, setn_010] = useState("0")
    const [n_110, setn_110] = useState("0")
    const [n_210, setn_210] = useState("0")

    const [n_011, setn_011] = useState("0")
    const [n_111, setn_111] = useState("0")
    const [n_211, setn_211] = useState("0")

    const [n_012, setn_012] = useState("0")
    const [n_112, setn_112] = useState("0")
    const [n_212, setn_212] = useState("0")

    const [n_013, setn_013] = useState("0")
    const [n_113, setn_113] = useState("0")
    const [n_213, setn_213] = useState("0")

    const [n_014, setn_014] = useState("0")
    const [n_114, setn_114] = useState("0")
    const [n_214, setn_214] = useState("0")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")
    const [dateFormat, setdateFormat] = useState("")

    const [autoPrintLoaded, setAutoPrintLoaded] = useState(false)


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("FormIVEntry disp user_key: ", res.data.Flag.user_key)
                //console.log("FormIVEntry disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("FormIVEntry disp GsbFlag: ", GsbFlag)
                //console.log("FormIVEntry disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("FormIVEntry disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("FormIVEntry disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;
                setdateFormat(GsbFlag.dateFormat);
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        (async () => {
            setRptName("")
            setshowButton(false)
            setShowWait(true)
            setisReadRec(true)
            setAutoPrintLoaded(false)
            try {
                //console.log("FormIVEntry onsubmit called", data)
                const res = await gsb.post('/Fbs_Report',
                {   sb_data: {
                        stkNo: qString,
                        nPage: 1,
                        limit: 0,
                    },
                    cPgmId: "Fbs_FormIVEntry",
                    cAction: "FormIVEntryGet",
                });

                console.log("currentFormIV: ", res.data.data) 

                if ( res.data.count > 0 ) {
                    setData(res.data.data)
                    setcurrentFormIV(res.data.data[0])

                    setn_001(utils.numToString2(res.data.data[0].d_001))
                    setn_101(utils.numToString2(res.data.data[0].d_101))

                    setn_002(utils.numToString2(res.data.data[0].d_002))
                    setn_102(utils.numToString2(res.data.data[0].d_102))

                    setn_004(utils.numToString2(res.data.data[0].d_004))
                    setn_104(utils.numToString2(res.data.data[0].d_104))

                    setn_006(utils.numToString2(res.data.data[0].d_006))
                    setn_106(utils.numToString2(res.data.data[0].d_106))

                    setn_007(utils.numToString2(res.data.data[0].d_007))
                    setn_107(utils.numToString2(res.data.data[0].d_107))

                    setn_008(utils.numToString2(res.data.data[0].d_008))
                    setn_108(utils.numToString2(res.data.data[0].d_108))

                    setn_009(utils.numToString2(res.data.data[0].d_009))
                    setn_109(utils.numToString2(res.data.data[0].d_109))

                    setn_010(utils.numToString2(res.data.data[0].d_010))
                    setn_110(utils.numToString2(res.data.data[0].d_110))

                    setn_011(utils.numToString2(res.data.data[0].d_011))
                    setn_111(utils.numToString2(res.data.data[0].d_111))

                    setn_012(utils.numToString2(res.data.data[0].d_012))
                    setn_112(utils.numToString2(res.data.data[0].d_112))

                    setshowButton(true)
                    setShowWait(false)
                    setcurrentMode("show")

                } else {
                    setshowButton(false)
                    setShowWait(false)
                    setcurrentMode("show")
                }
                setShowWait(false)
                setisReadRec(false)
            } catch (error) {
                showError(error)
            }
            setShowWait(false)
        })()
    }, [gsb])



    useEffect(() => {
        setn_201(utils.numToString2( utils.StringToNum2(n_001)+utils.StringToNum2(n_101) ))

        setn_202(utils.numToString2( utils.StringToNum2(n_002)+utils.StringToNum2(n_102) ))

        setn_204(utils.numToString2( utils.StringToNum2(n_004)+utils.StringToNum2(n_104) ))

        setn_206(utils.numToString2( utils.StringToNum2(n_006)+utils.StringToNum2(n_106) ))

        setn_207(utils.numToString2( utils.StringToNum2(n_007)+utils.StringToNum2(n_107) ))

        setn_208(utils.numToString2( utils.StringToNum2(n_008)+utils.StringToNum2(n_108) ))
        
        setn_209(utils.numToString2( utils.StringToNum2(n_009)+utils.StringToNum2(n_109) ))

        setn_210(utils.numToString2( utils.StringToNum2(n_010)+utils.StringToNum2(n_110) ))

        setn_211(utils.numToString2( utils.StringToNum2(n_011)+utils.StringToNum2(n_111) ))

        setn_212(utils.numToString2( utils.StringToNum2(n_012)+utils.StringToNum2(n_112) ))

        if (! isReadRec ) {
            setshowButton(false)
        }
    }, [gsb, selectedTabId, n_001, n_101, n_002, n_102, n_004, n_104, n_006, n_106, n_007, n_107, n_008, n_108, n_009, n_109, n_010, n_110, n_011, n_111, n_012, n_112])


    useEffect(() => {
        setn_003(utils.numToString2( utils.StringToNum2(n_001)+utils.StringToNum2(n_002) ))
        setn_103(utils.numToString2( utils.StringToNum2(n_101)+utils.StringToNum2(n_102) ))

        if (! isReadRec ) {
            setshowButton(false)
        }
    }, [gsb, selectedTabId, n_001, n_002, n_101, n_102])

    useEffect(() => {
        setn_005(utils.numToString2( utils.StringToNum2(n_003)+utils.StringToNum2(n_004) ))
        setn_105(utils.numToString2( utils.StringToNum2(n_103)+utils.StringToNum2(n_104) ))

        if (! isReadRec ) {
            setshowButton(false)
        }
    }, [gsb, selectedTabId, n_003, n_004, n_103, n_104])

    useEffect(() => {
        setn_013(utils.numToString2( utils.StringToNum2(n_006)+utils.StringToNum2(n_007)+utils.StringToNum2(n_008)+utils.StringToNum2(n_009)+utils.StringToNum2(n_010)+utils.StringToNum2(n_011)+utils.StringToNum2(n_012) ))
        setn_113(utils.numToString2( utils.StringToNum2(n_106)+utils.StringToNum2(n_107)+utils.StringToNum2(n_108)+utils.StringToNum2(n_109)+utils.StringToNum2(n_110)+utils.StringToNum2(n_111)+utils.StringToNum2(n_112) ))

        if (! isReadRec ) {
            setshowButton(false)
        }
    }, [gsb, selectedTabId, n_006, n_106, n_007, n_107, n_008, n_108, n_009, n_109, n_010, n_110, n_011, n_111, n_012, n_112])

    useEffect(() => {
        setn_014(utils.numToString2( utils.StringToNum2(n_013)-utils.StringToNum2(n_005) ))
        setn_114(utils.numToString2( utils.StringToNum2(n_113)-utils.StringToNum2(n_105) ))

        if (! isReadRec ) {
            setshowButton(false)
        }
    }, [gsb, selectedTabId, n_013, n_005, n_113, n_105])

    useEffect(() => {
        setn_203(utils.numToString2( utils.StringToNum2(n_003)+utils.StringToNum2(n_103) ))

        setn_205(utils.numToString2( utils.StringToNum2(n_005)+utils.StringToNum2(n_105) ))

        setn_213(utils.numToString2( utils.StringToNum2(n_013)+utils.StringToNum2(n_113) ))

        setn_214(utils.numToString2( utils.StringToNum2(n_014)+utils.StringToNum2(n_114) ))

        if (! isReadRec ) {
            setshowButton(false)
        }
    }, [gsb, selectedTabId, n_003, n_103, n_005, n_105, n_013, n_113, n_014, n_114])



    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
    }        


    const onFormIVEntrySaveRec = () => {
        setRptName("")
        setShowWait(true)
        setshowButton(false)
        setAutoPrintLoaded(false)
        ;

        currentFormIV.d_001 = utils.StringToNum2(n_001)
        currentFormIV.d_101 = utils.StringToNum2(n_101)

        currentFormIV.d_002 = utils.StringToNum2(n_002)
        currentFormIV.d_102 = utils.StringToNum2(n_102)

        currentFormIV.d_004 = utils.StringToNum2(n_004)
        currentFormIV.d_104 = utils.StringToNum2(n_104)

        currentFormIV.d_006 = utils.StringToNum2(n_006)
        currentFormIV.d_106 = utils.StringToNum2(n_106)

        currentFormIV.d_007 = utils.StringToNum2(n_007)
        currentFormIV.d_107 = utils.StringToNum2(n_107)

        currentFormIV.d_008 = utils.StringToNum2(n_008)
        currentFormIV.d_108 = utils.StringToNum2(n_108)

        currentFormIV.d_009 = utils.StringToNum2(n_009)
        currentFormIV.d_109 = utils.StringToNum2(n_109)

        currentFormIV.d_010 = utils.StringToNum2(n_010)
        currentFormIV.d_110 = utils.StringToNum2(n_110)

        currentFormIV.d_011 = utils.StringToNum2(n_011)
        currentFormIV.d_111 = utils.StringToNum2(n_111)

        currentFormIV.d_012 = utils.StringToNum2(n_012)
        currentFormIV.d_112 = utils.StringToNum2(n_112)

        console.log("onDivAdjSaveRec data", currentFormIV);
        (async () => {
            try {
                const res = await gsb.post('/Fbs_Report', {
                    sb_data: currentFormIV, 
                    cPgmId: "Fbs_FormIVEntry",
                    cAction: "FormIVEntrySave",
                })                
                if ( res.data.ok ) {
                    utils.showSuccess("Form IV record saved")
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
        
        setShowWait(false)
        setshowButton(true)
    }

    
    const onFFormIVEntrGenReport = () => {
        setRptName("")
        setShowWait(true)
        setshowButton(false)
        setShowNoRecord(false)
        setShowRpt(false)
        setRstdata([])
        setRptHead1("")
        setRptName("")
        setRptNameNo(0)
        setnPage(1)
        ProgressId2 = utils.genUUID()
        setProgressId(ProgressId2)
        setProgressValue(0)
        ;

        (async () => {
            try {
                const res = await gsb.post('/Fbs_Report',
                    {   sb_data: {
                            ProgressId: ProgressId2,
                            DataFormat: DataFormatValue,
                            nPage: 1,
                            cPrintMode: "PS",
                        },
                    cPgmId: "Fbs_FormIVEntry",
                    cAction: "FormIVEntrReport",
                })                
                //console.log("res.data.data: ", res.data.data) 
                if ( res.data.count > 0 ) {
                    setRstdata2([])
                    for (let j = 0; j < res.data.Rptdata.length; j++) {
                        Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                    }
                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRpt(true)
                    setRstdata(Rstdata2)
                    //console.log("Rstdata: ", Rstdata) 
                    setRptHead1(res.data.Rpthead1)
                    setRptName(res.data.RptName)
                    setRptNameNo(res.data.RptNameNo)
                    //console.log("RptName: ", RptName, RptNameNo) 
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(res.data.TotalPageNo)
                        for ( let j = 1; j <= res.data.TotalPageNo; j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                        if (res.data.RptNameNo > 0 ) {
                            for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                                aRptNameNo.push({n: j});
                            }
                            setRptName(res.data.RptName.replace(".pdf",""))
                        }
                    }
                } else {
                    setShowWait(false)
                    setShowNoRecord(true)
                    setShowRpt(false)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()

        setShowWait(false)
        setshowButton(true)
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

/*    
    // currentMode = show
    let detail = <PfentitEntryEdit gsb={gsb} currentPfentit={BlankPfentit} currentSmentit={currentSmentit} isNew onSave={newOnSave} onCancel={() => { setcurrentMode("show"); setSelectedTabId("list") } } ></PfentitEntryEdit>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <PfentitEntryEdit gsb={gsb} currentPfentit={BlankPfentit} currentSmentit={currentSmentit} isNew onSave={newOnSave} onCancel={() => { setcurrentMode("show"); setSelectedTabId("list") } } ></PfentitEntryEdit>
            break
        }
*/

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>

    let RptNameaRef = <>
        { RptNameNo > 0 && <div> Download / Print &nbsp;
            {aRptNameNo.map((no, j) => 
                <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
            )}
        </div> }
        { RptNameNo <= 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>}
        { RptName !== "" && ! DataFormatValue && <AutoPrint printed={autoPrintLoaded} onLoad={() => {setAutoPrintLoaded(true)}} href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`} /> }
    </>


    let list = <>
        <div className="Row">
            <Button disabled={true} className="Col-1-1" icon="add" onClick={() => { setcurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
            <Button disabled={false} className="Col-2-1" icon="confirm" onClick={() => { onFormIVEntrySaveRec() } }>Save</Button> 
            <Button disabled={! showButton} className="Col-4-2" icon="document" onClick={() => { setAutoPrintLoaded(true); onFFormIVEntrGenReport() } }>Download Report</Button> 
            <Button disabled={! showButton} className="Col-6-2" icon="document" onClick={() => { setAutoPrintLoaded(false); onFFormIVEntrGenReport() } }>Print Report</Button> 
        </div>
        <div className="Spacing-V-8" />
        {RptName.trim().length > 0 &&<div className="Spacing-V-8" />}
        {RptName.trim().length > 0 && RptNameaRef}
        <div className="Spacing-V-8" />
        <div >
            <div className="Spacing-V-16" />
            <div >
                NAME OF MEMBER: {CO_NAME}
            </div>
            <div >
                SCHEDULE OF SEGREGATION REQUIREMENTS AND FUNDS IN SEGREGATION AS AT :
            </div>
        </div>
        <div className="Spacing-V-16" />
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead><th>&nbsp;</th><th>&nbsp;</th><th>&nbsp;</th><th>&nbsp;</th><th>FORM IV</th></thead>
            <thead>
                <th className="TCol-1">NOTES</th>
                <th className="TCol-2">SEGREGATION REQUIREMENTS</th>
                <th className="TCol-3">HKFE TRADE</th>
                <th className="TCol-4">NON-HKFE TRADE</th>
                <th className="TCol-5">TOTAL</th>
            </thead>
            <tbody id="ma_tr">
                <tr >
                    <td className="TCol-1" onClick={() => { } }>6</td>
                    <td className="TCol-2" onClick={() => { } }> </td>
                    <td className="TCol-3" onClick={() => { } }> HKD</td>
                    <td className="TCol-4" onClick={() => { } }> HKD</td>
                    <td className="TCol-5" onClick={() => { } }> HKD</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }>1</td>
                    <td className="TCol-2" onClick={() => { } }>1. Net Ledger balance</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_001} value={n_001} onChange={utils.handleStringChange(n => setn_001(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_101} value={n_101} onChange={utils.handleStringChange(n => setn_101(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }>{n_201}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }>2</td>
                    <td className="TCol-2" onClick={() => { } }>2. Net floating profit/(loss) in Open futures/options contracts</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_002} value={n_002} onChange={utils.handleStringChange(n => setn_002(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_102} value={n_102} onChange={utils.handleStringChange(n => setn_102(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }>{n_202}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }> </td>
                    <td className="TCol-2" onClick={() => { } }>3. Net equity/(deficit) (total of item 1 and item 2)</td>
                    <td className="TCol-3" onClick={() => { } }> {n_003}</td>
                    <td className="TCol-4" onClick={() => { } }> {n_103}</td>
                    <td className="TCol-5" onClick={() => { } }> {n_203}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }>3</td>
                    <td className="TCol-2" onClick={() => { } }>4. Add accounts liquidating to adeficit and accounts with debit balance with no open trades</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_004} value={n_004} onChange={utils.handleStringChange(n => setn_004(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_104} value={n_104} onChange={utils.handleStringChange(n => setn_104(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }> {n_204}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }>4</td>
                    <td className="TCol-2" onClick={() => { } }>5. Amount required to be segregated (total of item 3 and item 4)</td>
                    <td className="TCol-3" onClick={() => { } }> {n_005}</td>
                    <td className="TCol-4" onClick={() => { } }> {n_105}</td>
                    <td className="TCol-5" onClick={() => { } }> {n_205}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }> </td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }></td>
                    <td className="TCol-2" onClick={() => { } }>FUNDS ON DEPOSIT IN SEGREGATION</td>
                    <td className="TCol-3" onClick={() => { } }></td>
                    <td className="TCol-4" onClick={() => { } }></td>
                    <td className="TCol-5" onClick={() => { } }></td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }> </td>
                    <td className="TCol-2" onClick={() => { } }>6. Deposited in segregated bank accounts</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_006} value={n_006} onChange={utils.handleStringChange(n => setn_006(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_106} value={n_106} onChange={utils.handleStringChange(n => setn_106(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }> {n_206}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }> </td>
                    <td className="TCol-2" onClick={() => { } }>7. Margins on deposit with clearing houses</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_007} value={n_007} onChange={utils.handleStringChange(n => setn_007(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_107} value={n_107} onChange={utils.handleStringChange(n => setn_107(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }> {n_207}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }>5</td>
                    <td className="TCol-2" onClick={() => { } }>8. Floating profit/(loss) due from/(to) clearing houses</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_008} value={n_008} onChange={utils.handleStringChange(n => setn_008(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_108} value={n_108} onChange={utils.handleStringChange(n => setn_108(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }> {n_208}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }> </td>
                    <td className="TCol-2" onClick={() => { } }>9. Margins on deposit with the members of the clearing houses</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_009} value={n_009} onChange={utils.handleStringChange(n => setn_009(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_109} value={n_109} onChange={utils.handleStringChange(n => setn_109(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }> {n_209}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }> </td>
                    <td className="TCol-2" onClick={() => { } }>10. Floating profit/(loss) due from/(to) the clearing members</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_010} value={n_010} onChange={utils.handleStringChange(n => setn_010(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_110} value={n_110} onChange={utils.handleStringChange(n => setn_110(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }> {n_210}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }> </td>
                    <td className="TCol-2" onClick={() => { } }>11. Margins on desposit with  dealers</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_011} value={n_011} onChange={utils.handleStringChange(n => setn_011(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_111} value={n_111} onChange={utils.handleStringChange(n => setn_111(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }> {n_211}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }> </td>
                    <td className="TCol-2" onClick={() => { } }>12. Floating profit/(loss) due from/(to) the dealers</td>
                    <td className="TCol-3" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_012} value={n_012} onChange={utils.handleStringChange(n => setn_012(n))}  /></td>
                    <td className="TCol-4" onClick={() => { } }><InputGroup id="inpuFormQty1" defaultValue={n_112} value={n_112} onChange={utils.handleStringChange(n => setn_112(n))}  /></td>
                    <td className="TCol-5" onClick={() => { } }> {n_212}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }></td>
                    <td className="TCol-2" onClick={() => { } }>13. Total amount in segregation (total of item 6 to item 12)</td>
                    <td className="TCol-3" onClick={() => { } }> {n_013}</td>
                    <td className="TCol-4" onClick={() => { } }> {n_113}</td>
                    <td className="TCol-5" onClick={() => { } }> {n_213}</td>
                </tr>
                <tr >
                    <td className="TCol-1" onClick={() => { } }></td>
                    <td className="TCol-2" onClick={() => { } }>14. Excess/(insufficient) funds in segregation (item 13 minus item 5) </td>
                    <td className="TCol-3" onClick={() => { } }> {n_014}</td>
                    <td className="TCol-4" onClick={() => { } }> {n_114}</td>
                    <td className="TCol-5" onClick={() => { } }> {n_214}</td>
                </tr>
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>


    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <div>
                        <H3>Form IV Entry</H3>
                    </div>
                    <div className="Spacing-V-16" />
                    {list}
                    <div className="Spacing-V-16" />
                    <p>Notes:</p>
                    <div>
                        <div>
                            1. This figure represents net client ledger balances, taking into account all credit and debit balances.
                        </div>
                        <div>
                            2. This floating profit/(loss) is the net figure, taking into account the floating profit/(loss) of all ledger
                        </div>
                        <div>
                           &nbsp;&nbsp;&nbsp;&nbsp;accounts (with both credit and debit balances).
                        </div>
                        <div>
                           3. These are debit balances arising AFTER floating profit/(Loss) has been accounted for( i.e. debit equity
                        </div>
                        <div>
                           &nbsp;&nbsp;&nbsp;&nbsp;balances). The Client cash balance may be in deficit but if there exists a larger floating profit, then the net
                        </div>
                        <div>
                           &nbsp;&nbsp;&nbsp;&nbsp;equity balance for this client will be a credit and is not required to be included here.
                        </div>
                        <div>
                           4. Amount required to be segregated is the sum of the credit equity balances of all Clients.
                        </div>
                        <div>
                          5. For HKFE trades, this floating profit/(loss) is disclosed as part of item 7. This resulted from amendments to
                        </div>
                        <div>
                           &nbsp;&nbsp;&nbsp;&nbsp;reporting requirments as of December 1,1993.
                        </div>
                        <div>
                            6. Indicate in which currency ledger balances are kept.
                        </div>
                    </div >

                </Card>
            </form>
        </>
    );
}

export default FormIVEntryMain